import { sxTable } from './sxProps';
import './styles.css'
import { Table, TableBody, TableContainer, TableHead, TableCell, TableRow, Paper, Checkbox } from '@mui/material';
import { styled } from '@mui/material/styles';
import { TabelaParcelasProps } from '../../../interfaces/props/Financeiro/DemonstrativoFatura/TabelaParcelasProps';
import { formatISOFormatToDate } from "../../../utils/DateFormat";
import { formatNumberToReais } from "../../../utils/MoneyFormat";
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';

function TabelaParcelas(props: TabelaParcelasProps) {

    const accessibility = useAccessibility();

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
    ...{
        fontFamily: 'Unimed-Sans',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 400,
    },
    ...accessibility.textStyleAccessibility
    }));
      
    const StyledTableRow = styled(TableRow)(({ theme }) => ({
      '&:nth-of-type(odd)': {
          backgroundColor: '#F9F9F9'
      },
    }));

    const onCheckboxRowClicked = (selectedIndex: number) => {
        if (selectedIndex === 0) return;

        props.onIndexChange(selectedIndex);
    }

    
    return (
        <div>
          <TableContainer className='container-table' sx={sxTable} component={Paper} style={accessibility.contrastBorderAccessibility}>
            <Table stickyHeader size="small" aria-label="a dense table">
                <TableHead>
                <TableRow tabIndex={0} sx={{ height: '48px' }}>
                    <StyledTableCell padding="checkbox" sx={{ paddingTop: '8px', paddingBottom: '8px' }}>
                        <Checkbox
                            indeterminate={props.index >= 0}
                            disabled
                            sx={{ 
                                color: props.index >= 0 ? '#00995D' : '#ccc',
                                '&.MuiCheckbox-indeterminate': { color: '#00995D' },
                                '&.Mui-disabled': { color: props.index >= 0 ? '#00995D' : '#ccc' }
                            }}
                        />
                    </StyledTableCell>
                    <StyledTableCell sx={{ 
                        paddingTop: '8px', 
                        paddingRight: '16px', 
                        paddingBottom: '8px'
                    }}>
                        <b>Vencimento</b>
                    </StyledTableCell>
                    <StyledTableCell align="right" sx={{ 
                        paddingTop: '8px', 
                        paddingRight: '16px', 
                        paddingBottom: '8px'
                    }}>
                        <b>Valor</b>
                    </StyledTableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {props.data.map((row) => (
                    <StyledTableRow
                        key={row.indice}
                        sx={{ 
                            '&:last-child td, &:last-child th': { border: 0 },
                            backgroundColor: row.indice === 0 ? '#F5F5F5' : 'inherit'
                        }}
                        tabIndex={0}
                    >
                        <StyledTableCell padding="checkbox">
                            <Checkbox
                                color="primary"
                                checked={row.indice <= props.index}
                                disabled={row.indice === 0}
                                style={accessibility.contrastColorAccessibility}
                                onChange={() => { onCheckboxRowClicked(row.indice) }}
                            />
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                            {formatISOFormatToDate(row.vencimentoOriginal)}
                        </StyledTableCell>
                        <StyledTableCell align="right">{formatNumberToReais(row.valorCorrigido)}</StyledTableCell>
                    </StyledTableRow>
                ))}
                </TableBody>
            </Table>
            </TableContainer>
        </div>
    )
}

export default TabelaParcelas;